import React from 'react';
import {
  HomeIcon,
  DocumentTextIcon,
  MicrophoneIcon,
  ArrowPathIcon,
  ClipboardDocumentListIcon,
  Cog6ToothIcon,
  ShieldCheckIcon,
} from '../icons';
import { useAuth } from '../contexts/AuthContext';
import AdminShell from '../components/admin/AdminShell';

const courtAdminNav = [
  { to: '/admin', label: 'Overview', icon: HomeIcon, end: true },
  { to: '/admin/sessions', label: 'Sessions', icon: MicrophoneIcon },
  { to: '/admin/transcriptions', label: 'Transcriptions', icon: DocumentTextIcon },
  { to: '/admin/certification', label: 'Certification', icon: ShieldCheckIcon },
  { to: '/admin/regeneration', label: 'Regeneration', icon: ArrowPathIcon },
  { to: '/admin/audit-log', label: 'Audit log', icon: ClipboardDocumentListIcon },
  { to: '/admin/settings', label: 'Setups', icon: Cog6ToothIcon },
];

const CourtAdminLayout = () => {
  const { user } = useAuth();

  return (
    <AdminShell
      portalLabel="Court Admin"
      portalSub={user?.court_name || 'Court'}
      navItems={courtAdminNav}
      accountSettingsPath="/admin/account-settings"
    />
  );
};

export default CourtAdminLayout;
